import React from 'react';
import { Characteristic } from '@/Models/Characteristic';
import PersonalityCharacteristicHeader from './Components/PersonalityCharacteristicHeader';
import PersonalityCharacteristicItem from './Components/PersonalityCharacteristicItem';

export interface CharacteristicsPanelProps {
    characteristics: Characteristic[];
}

function PersonalityCharacteristicsPanel({ characteristics }: CharacteristicsPanelProps): React.JSX.Element {
    return (
        <div className="grid grid-cols-12 items-start">
            <PersonalityCharacteristicHeader />
            {characteristics.map((characteristic) => (
                <PersonalityCharacteristicItem key={characteristic.characteristicName} {...characteristic} />
            ))}
        </div>
    );
}

export default PersonalityCharacteristicsPanel;
